import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import logo from '../assets/logo.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation(); 

  const navLinks = [
    { name: 'Profile', path: '/' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Facilities', path: '/facilities' },
    { name: 'Location', path: '/Location' },
    { name: 'Contact', path: '/Contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="sticky top-0 z-[100] bg-white/95 backdrop-blur-md border-b border-gray-100 font-poppins">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex justify-between items-center">
        
        {/* LOGO */}
        <Link to="/" className="flex items-center gap-3 group">
        {/* Logo Image */}
        <img 
            src={logo} // Pastikan sudah di-import di atas: import logo from '../assets/logo-ballaeja.png';
            alt="Logo Difa BallaEja" 
            className="h-10 md:h-12 w-auto object-contain transition-transform duration-300 group-hover:scale-105" 
        />
        
        {/* Logo Text */}
        <span className="text-xl md:text-2xl font-serif font-bold tracking-tighter text-gray-900 leading-none">
            VILLA<span className="text-red-600 group-hover:text-black transition-colors duration-300">BALLAEJA</span>
        </span>
        </Link>

        <div className="hidden md:flex items-center space-x-10">
          <div className="flex space-x-8 text-[12px] font-bold uppercase tracking-[0.2em]">
            {navLinks.map((link) => (
              <Link 
                key={link.name} 
                to={link.path} 
                className={`transition-colors duration-300 relative group ${
                  isActive(link.path) ? 'text-red-600' : 'text-gray-500 hover:text-red-600'
                }`}
              >
                {link.name}
                <span className={`absolute -bottom-1 left-0 h-0.5 bg-red-600 transition-all duration-300 ${
                  isActive(link.path) ? 'w-full' : 'w-0 group-hover:w-full'
                }`}></span>
              </Link>
            ))}
          </div>
          
          <Link 
            to="/booking" 
            className={`px-8 py-3 text-[12px] font-bold uppercase tracking-widest transition-all duration-300 shadow-lg active:scale-95 ${
              isActive('/booking') 
              ? 'bg-black text-white shadow-black/20' 
              : 'bg-red-600 text-white hover:bg-black shadow-red-600/20'
            }`}
          >
            Book Now
          </Link>
        </div>

        <button 
          className="md:hidden text-gray-800 p-2 hover:bg-gray-50 rounded-lg transition-colors"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      <div 
        className={`md:hidden absolute w-full bg-white border-b border-gray-100 overflow-hidden transition-all duration-500 ease-in-out ${
          isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="flex flex-col p-8 space-y-6 text-center font-bold uppercase tracking-[0.2em]">
          {navLinks.map((link) => (
            <Link 
              key={link.name} 
              to={link.path} 
              onClick={() => setIsOpen(false)} 
              className={`transition-colors ${
                isActive(link.path) ? 'text-red-600' : 'text-gray-700 hover:text-red-600'
              }`}
            >
              {link.name}
            </Link>
          ))}
          <Link 
            to="/booking" 
            onClick={() => setIsOpen(false)} 
            className={`py-4 shadow-xl font-bold uppercase tracking-widest ${
              isActive('/booking') ? 'bg-black text-white' : 'bg-red-600 text-white'
            }`}
          >
            Book Now
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;